import React from 'react'
import { Link } from 'react-router-dom'

import { getStatsPath } from '@app/modules/StatsDashboard/paths'
import { NavBarEntry } from '@app/NavBar'

export function useNavbarEntries(): NavBarEntry[] {
  return [
    {
      iconName: 'template',
      title: 'Statistik',
      EntryWrapper: ({ children }) => <Link to={getStatsPath()}>{children}</Link>,
      active: /^\/statistik/
    }
  ]
}
